import gql from 'graphql-tag';

export const GET_ALL_SHIPPING = gql`
  query FreightFindAll(
    $where: FreightWhereInput
    $skip: Int
    $take: Int
    $orderBy: [FreightOrderByWithRelationAndSearchRelevanceInput!]
  ) {
    FreightFindAll(skip: $skip, take: $take, where: $where, orderBy: $orderBy) {
      total
      data {
        id
        isCorrupted
        originCountry {
          id
          name
        }
        originCountryId
        originPort {
          id
          name
        }
        originPortId
        ql
        requestDate
        tt
        validity
        via
        freightTypeId
        freightType {
          id
          name
          quantityTypeId
        }
        destinyPortId
        destinyPort {
          id
          name
        }
        destinyCountryId
        destinyCountry {
          id
          name
        }
        continent
        company {
          id
          name
        }
        companyId
        corruptedObs
        Pricing {
          id
          isMainCurrency
          value
          currencyId
          currency {
            id
            name
          }
        }
      }
    }
  }
`;

export const GET_SHIPPING_BY_ID = gql`
  query FreightFindOne($where: FreightWhereUniqueInput!) {
    FreightFindOne(where: $where) {
      id
      isCorrupted
      originCountry {
        id
        name
      }
      originCountryId
      originPort {
        id
        name
        countryId
      }
      originPortId
      ql
      requestDate
      tt
      validity
      via
      freightTypeId
      freightType {
        id
        name
      }
      destinyPortId
      destinyPort {
        id
        name
        countryId
      }
      destinyCountryId
      destinyCountry {
        id
        name
      }
      continent
      company {
        id
        name
      }
      companyId
      corruptedObs
      Pricing {
        id
        isMainCurrency
        value
        currencyId
      }
    }
  }
`;

export const ADD_SHIPPING = gql`
  mutation FreightCreate($data: FreightCreateInput!) {
    FreightCreate(data: $data) {
      id
    }
  }
`;

export const UP_SHIPPING = gql`
  mutation FreightUpdate(
    $data: FreightUpdateInput!
    $where: FreightWhereUniqueInput!
  ) {
    FreightUpdate(data: $data, where: $where) {
      id
    }
  }
`;

export const GET_FREIGHT_DESTINATION_PORTS = gql`
  query FreightDestinationPorts($originPortId: Int!, $quantityTypeId: Int) {
    FreightDestinationPorts(originPortId: $originPortId, quantityTypeId: $quantityTypeId) {
      portId
      name
      freightCount
    }
  }
`;
